import { styled } from '@mui/material/styles';

import MuiDialogTitle from '@mui/material/DialogTitle';

const DialogTitle = styled(props => <MuiDialogTitle {...props} />)(({ theme }) => ({
  color: theme.palette.primary.dark,
}));

export default DialogTitle;
